// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aikK","left":"styles_left__2rFAB","desktopActions":"styles_desktopActions__f4SHh","title":"styles_title__3MOWL"};